import { Provider, inject } from '@angular/core';

import { ON_APP_INIT_BOOTSTRAPPER } from '../bootstrap/bootstrapper.service';
import { ProductService } from '../products/product.service';
import { DatadogRumBootstrapService } from './datadog-rum.bootstrap.service';

export function provideDatadogRum(): Provider[] {
    return [
        DatadogRumBootstrapService,
        {
            provide: ON_APP_INIT_BOOTSTRAPPER,
            multi: true,
            deps: [ProductService],
            useFactory: (productService: ProductService) => {
                return productService.isSingleDomainApp ? inject(DatadogRumBootstrapService) : { onAppInit: () => {} };
            },
        },
    ];
}
